import { Service, Inject } from 'vue-di-container';
import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { ServiceRatingModel } from './ServiceRatingModel';

@Service()
export default class RatingService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async addRating(model: ServiceRatingModel): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = `${window.$config.HostName}api/service-ratings`;
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            throw error;
        }
    }

    public async getRatings(
        providerName: string,
        serviceType: number | null,
        fromDate: string,
        toDate: string,
        pageIndex: string,
        pageSize: string
    ): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const params: string[] = [
                `providerName=${encodeURIComponent(providerName)}`,
                `pageIndex=${pageIndex}`,
                `pageSize=${pageSize}`
            ];
            if (serviceType != null) {
                params.push(`serviceType=${serviceType}`);
            }
            if (fromDate) { params.push(`fromDate=${encodeURIComponent(fromDate)}`); }
            if (toDate) { params.push(`toDate=${encodeURIComponent(toDate)}`); }

            const url = `${window.$config.HostName}api/service-ratings?${params.join('&')}`;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async canRate(serviceType: number): Promise<boolean> {
        try {
            const url = `${window.$config.HostName}api/service-ratings/can-rate?serviceType=${serviceType}`;
            const result = await this.axiosService.axiosInstance.get(url);
            return result.data && result.data.isSuccess && result.data.result === true;
        } catch (error) {
            return false;
        }
    }

    public async GetBoxes(): Promise<any> {
        try {
            const url = window.$config.HostName + 'api/service-ratings/ratings-boxes';
            const result = await this.axiosService.axiosInstance.get(url);
            return result.data;
        } catch (exception) {
            return false;
        }
    }

}